<template>
  <div>
    <section class="daily-section-web">
      <a href="/market-price">
      <div class="daily-head">
        <h6>Daily Marketprice</h6>
          <h2 class="marketprice_text">
        <span class="color" v-for="item in market" :key="item.market_price_id">
          {{
            selectedLanguage === "en"
            ? item.sub_category_name
            : item.tn_sub_name
          }}
          
          <span class="material-symbols-outlined">₹</span>
          {{ item.price }}/{{ selectedLanguage === 'en'
                  ? item.quantity_type
                  : item.quantity_type_tamil }}
          <span
            class="material-symbols-outlined"
          ><img src="../assets/images/footer-component/icon.svg" loading="lazy" alt="geo-alt"></span>
          {{
            selectedLanguage === "en"
            ? item.place
            : item.tn_place
          }} on {{ formatDate(item.created) }} ||
        </span>
          </h2>
      </div>
      </a>
    </section>
  </div>
</template>

<script>
import { en, ta } from "@/translations";

export default {
  props: ["selectedLanguage"], // Receive the selectedLanguage prop from App.vue

  data() {
    return {
      market: []
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    },
  },
  mounted() {
    fetch("https://vaiyal-app.herokuapp.com/get/recentlist?type=market")
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          this.market = data.data;
          // console.log(this.market);
        } else {
          console.error("Failed to fetch recent product data:", data.msg);
        }
      })
      .catch(error => {
        console.error("Error fetching recent product data:", error);
      });
  },
  methods: {
    formatDate(date) {
      const dateObject = new Date(date);
      const day = String(dateObject.getDate()).padStart(2, "0");
      const month = String(dateObject.getMonth() + 1).padStart(2, "0");
      const year = String(dateObject.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    }
  }
};
</script>

<style>
@import url("/src/components/DailymarketComponent.scss");

</style>